module.exports = __webpack_public_path__ + "img/ring_r_c_1_1.19a9ee16.png";